export const THEME_MODE = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;
export type ThemeMode = ConstType<typeof THEME_MODE>;
export const THEME_LS_KEY = 'theme';
